import type { JourneyCoreState, JourneySpec, JourneyStep } from '../../journey'

export type VehiclePriceView = 'home' | 'loading' | 'users' | 'permissions'

export interface VehiclePriceState extends JourneyCoreState {
  view: VehiclePriceView
  navActive: 'inicio' | 'usuarios'
  /** Starts granted: la migración dejó el permiso activo para todos. */
  permissionChecked: boolean
  permissionHighlighted: boolean
  saving: boolean
  savedToast: boolean
}

const INITIAL: VehiclePriceState = {
  view: 'home',
  caption: 'Todo comienza en Inicio',
  target: null,
  cursorVisible: true,
  clicking: false,
  clickSeq: 0,
  navActive: 'inicio',
  permissionChecked: true,
  permissionHighlighted: false,
  saving: false,
  savedToast: false,
}

/*
Un solo recorrido: dónde está la casilla.

La primera versión mostraba también la ficha del vehículo con el precio
congelado, para explicar qué provoca quitar el permiso. Es una explicación de
más: quien abre el anuncio necesita saber que el permiso existe, que ya viene
activado y por dónde se cambia. Lo demás lo descubre en la pantalla el día que
lo use.
*/
const build = (): JourneyStep<VehiclePriceState>[] => [
  { at: 700, patch: { target: 'navUsuarios' } },
  { at: 1900, click: true, patch: { navActive: 'usuarios', caption: 'Entramos a Usuarios' } },
  { at: 2200, patch: { view: 'loading' } },
  { at: 2900, patch: { view: 'users', caption: 'Elegimos a la persona' } },
  { at: 3400, patch: { target: 'member' } },
  { at: 4500, click: true, patch: { caption: 'Abrimos su perfil' } },
  { at: 4800, patch: { view: 'loading' } },
  { at: 5500, patch: { view: 'permissions', caption: 'Los permisos de siempre' } },
  { at: 6100, patch: { target: 'permissionBox' } },
  { at: 6600, patch: { permissionHighlighted: true, caption: 'El permiso nuevo, ya marcado para todos' } },
  {
    at: 7600,
    click: true,
    patch: { permissionChecked: false, caption: 'Se desmarca a quien no deba cambiar precios' },
  },
  { at: 9000, patch: { target: 'save' } },
  { at: 10000, click: true, patch: { saving: true, permissionHighlighted: false } },
  { at: 10300, patch: { saving: false, savedToast: true, caption: 'Guardamos y listo' } },
  { at: 12000, patch: { caption: 'Nada cambia hasta que usted lo decida' } },
]

export const vehiclePriceSpec: JourneySpec<VehiclePriceState> = {
  initial: INITIAL,
  loopMs: 15_000,
  build,
}
